import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import "../../assets/css/Staff/Staff.css"
import "../../assets/css/Credential/Credential.css"
import configure from "configure"
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import HostingPanelLive from "./Tabs/HostingPanelLive"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import "../../assets/css/Scollbar.css"
import SimpleBar from "simplebar-react"
import secureLocalStorage from "react-secure-storage"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import CredentailSearch from "./CredentialSearch"
import { Link, useLocation, useNavigate } from "react-router-dom"

// components

const Crendential = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [credId, setCreID] = useState("")
  const [isCollapse, setIsCollapse] = useState(true)
  const [loading, setLoading] = useState(true)
  const [navItemData, setNavItemData] = useState([])
  const [allData, setAllData] = useState([])
  const [projectOption, setProjectOption] = useState([])
  const [tableData, setTableData] = useState({})
  const [isIndex, setIsIndex] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [isSearch, setIsSearch] = useState(false)
  const [boxWidth, setBoxWidth] = useState(0)
  const [mainAllData, setMainAllData] = useState([])
  const location = useLocation()
  document.title = "Credentials | Zithas Crm"
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth
      setBoxWidth(viewportWidth * 0.9)
    }
    updateWidth()
    window.addEventListener("resize", updateWidth)
    return () => window.removeEventListener("resize", updateWidth)
  }, [])

  const [fixedSideTab, setFixedSideTab] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 68) {
      setFixedSideTab(true)
    } else {
      setFixedSideTab(false)
    }
  })

  const fatchAllTabData = async () => {
    // knowledgeTopics
    setLoading(true)
    // role_id,user_id
    const roleId = secureLocalStorage.getItem("auth_role")
    const authId = localStorage.getItem("auth_id")
    const formData = new FormData()
    formData.append("role_id", roleId)
    formData.append("user_id", authId)

    try {
      const response = await axios({
        method: "post",
        url: `${configure.apiUrl}/credentials`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (response) {
        setLoading(false)
        setverticalActiveTab(response?.data?.data[0]?.id)
        setCreID(response?.data?.data[0]?.id)
        setTableData(response?.data?.data[0])
        setNavItemData(response?.data?.data || [])
        setAllData(response?.data?.data)
        setMainAllData(response?.data?.data)
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const fetchAllProjects = async () => {
    setLoading(true)
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/getProjects`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (response) {
        const createProjectOption = response.data.data?.map(items => {
          return {
            label: items.project_name,
            value: items.id,
          }
        })
        setProjectOption(createProjectOption)
      }
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }
  useEffect(() => {
    if (projectOption?.length == 0) {
      fetchAllProjects()
    }
  }, [])
  useEffect(() => {
    if (allData?.length == 0) {
      fatchAllTabData()
    }
  }, [])

  const handleHover = () => {
    setIsIndex(true)
  }
  const handleLeave = () => {
    setIsIndex(false)
  }
  useEffect(() => {
    if (location?.search != "") {
      const params = new URLSearchParams(location?.search)
      const tabId = parseInt(params.get("tab"))
      const credentialId = parseInt(params.get("credential"))
      const matchedTab = mainAllData?.find(tab => tab.id == tabId)

      const filteredResult = []

      if (matchedTab) {
        const matchedCredential = matchedTab.credentials?.find(
          c => c.id == credentialId
        )
        if (matchedCredential) {
          filteredResult.push({
            ...matchedTab,
            credentials: [matchedCredential],
          })
        }
      }
      setverticalActiveTab(filteredResult[0]?.id)
      setCreID(filteredResult[0]?.id)
      setTableData(filteredResult[0])
      setNavItemData(filteredResult || [])
      setAllData(filteredResult)
      setIsSearch(false)
    }
  }, [mainAllData, location])

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title="Credentials" breadcrumbItem="Credentials" />
          <div className="d-flex align-items-center col-md-6  global-cred">
            <div className="me-3 col-md-6">
              <input
                id="search-bar-0"
                type="text"
                className=" form-control h-100 w-100 "
                placeholder={`Search Globaly...`}
                value={searchValue}
                onChange={e =>
                  setSearchValue(e.target.value?.toLocaleLowerCase())
                }
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    setIsSearch(true)
                  }
                }}
              />
            </div>
            <button
              className="btn btn-sm  bg-purple text-white me-2"
              onClick={e => {
                setIsSearch(true)
              }}
            >
              <i className="bi bi-funnel-fill fs-6"></i>
            </button>
            <Link
              to={`${configure.appUrl}credentials`}
              className="btn btn-sm  me-1 bg-warning  text-white "
              onClick={e => {
                setverticalActiveTab(mainAllData[0]?.id)
                setCreID(mainAllData[0]?.id)
                setTableData(mainAllData[0])
                setNavItemData(mainAllData || [])
                setAllData(mainAllData)
                setIsSearch(false)
                setSearchValue('')
              }}
            >
              <i className="bi bi-x fs-6"></i>
            </Link>
          </div>
          <div id="credentialPage">
            <Row
              className={`gx-4 justify-content-between di-flex align-items-top `}
              id="cred"
            >
              <div
                className={`px-0 sidebar-containerr ${
                  fixedSideTab && "credtabFix"
                }`}
                style={isIndex ? { zIndex: "2" } : {}}
              >
                <div className="position-relative">
                  <div>
                    <SimpleBar
                      style={{ height: "70vh" }}
                      className={`${fixedSideTab && "fix-simplebar"}`}
                    >
                      <Nav
                        pills
                        className={`${
                          fixedSideTab && "credtabFix-ul"
                        }  flex-column px-1 py-1 h-100`}
                      >
                        {navItemData?.map(items => {
                          function getInitials(text) {
                            let words = text.split(" ")
                            let initials = ""
                            words.forEach(word => {
                              let initial = word.charAt(0).toUpperCase()
                              initials += initial
                            })
                            return initials
                          }
                          let initials = getInitials(items.tab_name)
                          return (
                            <NavItem
                              // className="d-flex flex-column gap-2 mb-2"
                              key={items.id}
                              className={classnames({
                                "d-flex flex-column gap-2 mb-2": true,
                                active: verticalActiveTab == `${items.id}`,
                              })}
                              title={items.tab_name}
                            >
                              <NavLink
                                // className="text-center crendential"
                                onClick={() => {
                                  setCreID(items.id)
                                  setverticalActiveTab(items.id)
                                  setTableData(items)
                                }}
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  "text-center crendential px-0": true,
                                  active: verticalActiveTab == `${items.id}`,
                                })}
                                onMouseEnter={handleHover}
                                onMouseLeave={handleLeave}
                              >
                                {initials}
                                <span className="link_name border-start border-white border-2">
                                  {items.tab_name}
                                </span>
                              </NavLink>
                            </NavItem>
                          )
                        })}
                      </Nav>
                    </SimpleBar>
                  </div>
                </div>
              </div>
              <Col
                md={isCollapse ? "11" : "10"}
                className={`z-1 pe-0 credential-table ${
                  isCollapse && "width-94 ps-0"
                }`}
              >
                <div className="card p-4 h-100">
                  <TabContent
                    activeTab={verticalActiveTab}
                    className="text-muted mt-4 mt-md-0"
                  >
                    <TabPane tabId={verticalActiveTab}>
                      <HostingPanelLive
                        verticalActiveTab={verticalActiveTab}
                        tableData={tableData}
                        credId={credId}
                        setLoading={setLoading}
                        setTableData={setTableData}
                        setNavItemData={setNavItemData}
                        projectOption={projectOption}
                        setverticalActiveTab={setverticalActiveTab}
                        navItemData={navItemData}
                        allData={allData}
                        setAllData={setAllData}
                      />
                    </TabPane>
                  </TabContent>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
        <div className={`note-sticky-form ${isSearch ? "d-block" : "d-none"}`}>
          <Draggable>
            <ResizableBox
              width={boxWidth}
              style={{
                position: "fixed",
                top: "10%",
                right: "5%",
                zIndex: "1055",
                backgroundColor: "#fff",
                maxHeight: "fit-content",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div className="modal-header pe-4">
                <h5 className="modal-title mt-0">Global Credential Search</h5>
                <button
                  type="button"
                  onClick={() => {
                    setIsSearch(false)
                  }}
                  className="btn-modal-close"
                >
                  <span aria-hidden="true" className="btn-modal-span">
                    &times;
                  </span>
                </button>
              </div>
              <CredentailSearch
                allData={allData}
                searchValue={searchValue}
                isSearch={isSearch}
                mainAllData={mainAllData}
              />
            </ResizableBox>
          </Draggable>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Crendential
